import {AccessEntities, AccessLevel} from "../utils/global-functions-and-types";

export class RequiredAccessLevel {
  accessEntity?: AccessEntities = undefined
  accessLevel?: AccessLevel = "READER"
  needsCompany?: boolean = true
  checkRolesOnly?: boolean = false
  checkCompany?: boolean = false
}
